import { render, staticRenderFns } from "./NewProxyModal.vue?vue&type=template&id=643ec242&scoped=true"
import script from "./NewProxyModal.vue?vue&type=script&lang=js"
export * from "./NewProxyModal.vue?vue&type=script&lang=js"
import style0 from "./NewProxyModal.vue?vue&type=style&index=0&id=643ec242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ec242",
  null
  
)

export default component.exports